import { getAccountUrl } from '@/utils/modules/Common'

const INVENTORY = 'inventory'
const ITEM_REGIST = 'inventory/regist'
const ITEM = 'item'
const management = 'management'
const COMMON = 'common'
const SAFETY = 'safety'
const instId = ':instituteId'
const RoutePath = {
	sso: `${getAccountUrl()}/SignIn?redirect=${
		window.location.origin
	}&pro=true`,
	home: '/',
	user: {
		main: `/${instId}/user`,
		name: `/${instId}/change/name`,
		email: `/${instId}/change/email`,
		phone: `/${instId}/change/phone`,
		pw: `/${instId}/change/pw`,
		noticeSetting: `/${instId}/setting/notice`,
		language: `/${instId}/setting/language`,
	},
	dashboard: `/${instId}/dashboard`,
	bundle: '/bundle',
	inventory: {
		list: `/${instId}/${INVENTORY}`,
		beingRegisteredList: `/${instId}/${INVENTORY}/beingRegistered/list`,
		analyzingItem: `/${instId}/${INVENTORY}/beingRegistered/item/:itemId`,
		analyzing: `/${INVENTORY}/analyzing`,
		expired: `/${instId}/${INVENTORY}/expired`,
		safetyThreshold: `/${instId}/${INVENTORY}/safetyThreshold`,
		disposal: `/${instId}/${INVENTORY}/disposal`,
		deleteDisposal: `/${instId}/${INVENTORY}/deleteDisposal`,
		detail: `/${instId}/${INVENTORY}/item`,
		divide: `/${instId}/${INVENTORY}/divide`,
		divideInfo: `/${instId}/${INVENTORY}/divide/info/`,
		editDetailInfo: `/${instId}/${INVENTORY}/divide/info/edit`,
		registSearch: `/${instId}/${ITEM_REGIST}/search`,
		registType: `/${instId}/${ITEM_REGIST}/type/info`,
		registAsQRcode: `/${ITEM_REGIST}/qrcode`,
		registAsBrand: `/${ITEM_REGIST}/brand`,
		registAsCasNo: `/${ITEM_REGIST}/cas`,
		registAsDirectInput: `/${ITEM_REGIST}/inputDirect`,
		registInfo: `/${instId}/${ITEM_REGIST}/info`,
		registCount: `/${instId}/${ITEM_REGIST}/count`,
		formRegistDetail: `/${instId}/${ITEM_REGIST}/detail`,
		inputReason: `/${instId}/${ITEM}/reason`,
		registComplete: `/${instId}/${INVENTORY}/complete`,
		inputUsage: `/${instId}/${ITEM}/inputUsage`,
		inputIngredient: `/${instId}/${ITEM_REGIST}/inputIngredient`,
		brandList: `/${instId}/${ITEM_REGIST}/brandList`,
		brandForm: `/${instId}/${ITEM_REGIST}/brandForm`,
		history: `/${instId}/${INVENTORY}/history`,
		itemCreate: `/${instId}/${INVENTORY}/:categoryId/create/item`,
		itemCreateCamera: `/${instId}/${INVENTORY}/:categoryId/create/camera`,
		itemCreateCount: `/count`,
	},
	management: {
		menu: `/${instId}/${management}/menu`,
		history: `/${instId}/${management}/record`,
	},
	common: {
		selectMember: `/${instId}/${COMMON}/member/:type`,
		selectStorage: `/${instId}/${COMMON}/select/storage`,
	},
	institution: {
		main: `/${instId}/institution/main`,
		info: `/${instId}/institution/info`,
		orgainzation: `/${instId}/institution/organization`,
		groupinfo: `/${instId}/institution/group/:groupId/info`,
		memberinfo: `/${instId}/institution/member/:memberId/info`,
		location: `/${instId}/institution/location`,
		storageinfo: `/${instId}/institution/location/storage/:storageId/info`,
		storageList: `/${instId}/institution/location/storage/:locationId/list`,
		subStorage: `/${instId}/institution/location/subStorage/:subStorageId/`,
		storageInventory: `/${instId}/institution/:storageId/items`,
	},
	safety: {
		main: `/${instId}/${SAFETY}`,
		msds: `/${instId}/${SAFETY}/msds`,
		msdsDetail: `/${instId}/${SAFETY}/msds/detail`,
		hazardousMaterial: `/${instId}/${SAFETY}/hazardousMaterial`,
		hazardousMaterialList: `/${instId}/${SAFETY}/hazardousMaterial/list`,
		specialManagement: `/${instId}/${SAFETY}/specialManagement`,
		specialManagementList: `/${instId}/${SAFETY}/specialManagement/list`,
		healthCheck: `/${instId}/${SAFETY}/healthCheck`,
		healthCheckupDetail: `/${instId}/${SAFETY}/healthCheckup/:userId/info`,
		healthCheckupUsageHistory: `/${instId}/${SAFETY}/healthCheckup/:userId/usage/history`,
		healthCheckupHistory: `/${instId}/${SAFETY}/healthCheckup/:userId/history`,
		dangerous: `/${instId}/${SAFETY}/dangerousStorage`,
		dangerousSub: `/${instId}/${SAFETY}/dangerousStorage/sub/:id`,
		dangerousDetail: `/${instId}/${SAFETY}/dangerousStorage/detail/:id`,
		management: `/${instId}/${SAFETY}/management`,
		dangerousInventoryList: `/${instId}/${SAFETY}/dangerousStorage/list`,
		lawProductByGroup: `/${instId}/${SAFETY}/lawProductByGroup`,
		lawProductByGroupItem: `/${instId}/${SAFETY}/lawProductByGroup/list`,
	},
	invite: {
		accept: `/acceptInvite`,
		institute: `/acceptInvite/institute`,
		expire: `/acceptInvite/institute/licenseExpire`,
	},
	auth: {
		emailAuthentication: `/auth/emailAuthentication`,
	},
	Cargo: {
		Main: `/:instituteId/cargo`,
		Do: `/:instituteId/cargo/do`,
		Detail: `/:instituteId/cargo/:id`,
	},
	GlobalFilter: `/:instituteId/filter`,
}

export default RoutePath
